/**
 * Different store setup is used in production and development environment
 */
if (process.env.NODE_ENV === 'production') {
    module.exports = require('./store.prod');
} else {
    module.exports = require('./store.dev');
}
